import { render, staticRenderFns } from "./CardChallengesDate.vue?vue&type=template&id=f369edf8&"
import script from "./CardChallengesDate.vue?vue&type=script&lang=js&"
export * from "./CardChallengesDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports